module.exports = __webpack_public_path__ + "img/house_13.53577aa3.jpg";